import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Jobs by worker")
  ])
], -1)
const _hoisted_3 = {
  key: 1,
  id: "chart"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createElementBlock("div", {
      class: "card-body",
      key: _ctx.key
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (!_ctx.isEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_apexchart, {
                type: "pie",
                height: "400",
                options: _ctx.chart.options,
                series: _ctx.chart.options.series
              }, null, 8, ["options", "series"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_empty, { description: "No data for the selected filters" })
            ]))
    ]))
  ]))
}